import { axios } from 'lib/axios';

export const loginWithTwitter = ({ code }) => {
  return axios.get(`/v2/oauth/twitter/callback?code=${code}`);
};
